import { type FeedbackSurveyContact } from '@aikoa/api'
import { type ContactMethod, getPhoneData } from '@aikoa/common'

export function deriveFeedbackContactMethod(contact: FeedbackSurveyContact): ContactMethod | null {
  const phone = contact.phone ? getPhoneData(contact.phone)?.phoneNumber : undefined

  if (phone) {
    return { type: 'phone', value: phone }
  }

  const email = contact.email?.trim().toLowerCase()

  if (email) {
    return { type: 'email', value: email }
  }

  return null
}
